import { fetch as __fetch } from 'whatwg-fetch';

const FLOWS_URL = `/DriftsdataApi/PowerFlows`;
const SITUATIONS_URL = `/DriftsdataApi/PowerSituations`;
const FREQUENCY_URL = `/DriftsdataApi/Frequency`;
const MIN_VALID_FREQUENCY = 48;
const MAX_VALID_FREQUENCY = 51;

export async function fetchFlows() {
    return await get(FLOWS_URL);
}

export async function fetchSituations(lang) {
    return await get(`${SITUATIONS_URL}?lang=${lang}`);
}

export async function fetchFrequency() {
    const frequency = await get(FREQUENCY_URL);
    const numericFrequency = Number(frequency);

    if(
        !Number.isFinite(numericFrequency)
        || numericFrequency < MIN_VALID_FREQUENCY
        || numericFrequency > MAX_VALID_FREQUENCY
    ) {
        throw new RangeError(`Invalid frequency value: ${frequency}`);
    }

    return frequency;
}

async function get(url) {
    const response = await __fetch(url);

    if(response.ok) {
        return response.json();
    }
    
    throw response;
}
